import {Injectable, Injector} from '@angular/core';

import {Observable, of} from 'rxjs';

import {BaseService} from '../base/base.service';

import {AppModulePath} from '../../models/app-module-path';
import {AppUser} from '../../models/security/app_user';
import {Query} from '../../models/query/query';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {catchError, map} from 'rxjs/operators';
import {WebMethodResult} from '../../models/web-method-result';
import {isNil} from 'lodash';
import {TranslateService} from '@ngx-translate/core';

@Injectable({providedIn: 'root'})
export class SecurityService extends BaseService {

  private loginUrl = 'auth/login';

  private grantedActivitiesUrl = 'api/appUser/getGrantedActivities';
  private getLoggerUserUrl = 'api/appUser/get_logged_user';
  private logoutUrl = 'api/appUser/log_out';
  private listUrl = 'api/appUser/list';
  private setLangUrl = 'api/appUser/set_lang';

  private _loggedUser: AppUser = null;

  public get loggedUser(): AppUser {
    if (!isNil(this._loggedUser)) {
      return this._loggedUser;
    }
    const stored = localStorage.getItem('loggedUser');
    if (!isNil(stored)) {
      try {
        this._loggedUser = new AppUser(JSON.parse(stored));
      } catch {}
    }
    return this._loggedUser;
  }

  public set loggedUser(user: AppUser) {
    this._loggedUser = user;
  }

  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation,
              private translateService: TranslateService) {
    super(injector, http2, platformLocation);
    this.applyLoggedUserLanguage();
  }

  public list(qry: Query): Observable<AppUser[]> {
    return this.post<AppUser[]>(this.listUrl, AppModulePath.OSNOVNA_SREDSTVA_REVERSI_SREDSTAVA, qry).pipe(
      map(res => res.map(obj => new AppUser(obj))),
      catchError(this.handleError));
  }

  // public initGrantedActivities(): Observable<any> {
  //   return this.get(this.grantedActivitiesUrl, AppModulePath.GRANTED_ACTIVITIES).pipe(
  //     map((res: HttpResponse<any>) => {
  //       sessionStorage.setItem('grantedActivities', JSON.stringify(res));
  //       return res;
  //     }),
  //     catchError(this.handleError));
  // }

  public getGrantedActivities(): any {
    if (!isNil(this.loggedUser)) {
      return this.loggedUser.grantedActivities;
    }
    return null;
    // const grantedActivities = sessionStorage.getItem('grantedActivities');
    // // ako uopste nema prava:
    // if (grantedActivities === '') {
    //   return null;
    // }
    //
    // if (grantedActivities != null) {
    //   return JSON.parse(grantedActivities);
    // } else {
    //   return null;
    // }
  }

  public fetchLoggerUser(): Observable<AppUser> {
    return of(this.loggedUser);
    // return this.get<AppUser>(this.getLoggerUserUrl, AppModulePath.GET_LOGGED_USER).pipe(
    //   map(res => {
    //     // this.loggedUser = new AppUser(res);
    //     localStorage.setItem('loggedUser', JSON.stringify(this.loggedUser));
    //     return this.loggedUser;
    //   }));
  }

  public logout()/*: Observable<any>*/ {
    localStorage.removeItem('loggedUser');
    this.loggedUser = null;
    this.translateService.use('sr-Latn');
    // promeni ovu konstantu AppModulePath.GRANTED_ACTIVITIES u nešto pametno
    // return this.post(this.logoutUrl, AppModulePath.GET_LOGGED_USER, '{data:1}');
    return of({});
  }

  public setLang(lang: string): Observable<any> {
    return this.postText(this.setLangUrl + `/${this.loggedUser.id}/${lang}`, AppModulePath.GET_LOGGED_USER, null).pipe(
      map(res => {
        this.persistLoggedUser();
        this.applyLoggedUserLanguage();
        return res;
      }),
      catchError(this.handleError)
    );
  }

  public login(userName: string, password: string): Observable<AppUser> {
    return this.post<any>(this.loginUrl, AppModulePath.GET_LOGGED_USER, { userName: userName, password: password }).pipe(
      map(res => {
        const lUser = new AppUser(res.authUser);
        lUser.accessToken = res.accessToken;
        this.loggedUser = lUser;
        this.persistLoggedUser();
        this.applyLoggedUserLanguage();
        return this.loggedUser;
      }),
      catchError(this.handleError));
  }

  private applyLoggedUserLanguage(): void {
    this.translateService.setDefaultLang('sr-Latn');
    const uiLang = this.loggedUser ? this.loggedUser.uiLang : 'sr-Latn';
    this.translateService.use(uiLang);
  }

  private persistLoggedUser(): void {
    if (isNil(this.loggedUser)) {
      localStorage.removeItem('loggedUser');
      return;
    }

    localStorage.setItem('loggedUser', JSON.stringify(this.loggedUser));
  }
}
